export default "<p>Please wait ...</p>\r\n"